import { render, staticRenderFns } from "./PlanReg.vue?vue&type=template&id=684505e0&"
import script from "./PlanReg.vue?vue&type=script&lang=js&"
export * from "./PlanReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports